export const SLICE_NAME = 'vaReporterSources';
